module.exports = __webpack_public_path__ + "static/img/icone66@3x.85ffd98.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icone66@3x.png
// module id = vWsc
// module chunks = 1